const eur = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const hours = new Intl.NumberFormat('nl-NL', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
})

const percent = new Intl.NumberFormat('nl-NL', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
})

const compact = new Intl.NumberFormat('nl-NL', {
  maximumFractionDigits: 1,
})

export function formatEuros(amount: number): string {
  return eur.format(amount)
}

export function formatHours(value: number): string {
  return hours.format(value)
}

export function formatContractHours(value: number): string {
  return Number.isInteger(value) ? String(value) : hours.format(value)
}

export function formatPercent(fraction: number): string {
  return percent.format(fraction)
}

const MONTHS_LONG = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December']

/** "Maart 2026". Met hoofdletter, want het gebruik is een kop; in een zin `.toLowerCase()`. */
export function formatMonthYear(month: number, year: number): string {
  return `${MONTHS_LONG[month - 1]} ${year}`
}

export function formatCompactEuros(amount: number): string {
  const abs = Math.abs(amount)
  const sign = amount < 0 ? '-' : ''
  if (abs >= 1_000_000) return `${sign}${compact.format(abs / 1_000_000)}M`
  if (abs >= 1_000) return `${sign}${compact.format(abs / 1_000)}k`
  return `${sign}${Math.round(abs)}`
}
